import { Box, Typography } from '@mui/material';
import React from 'react';
import { MAPPED_TOPICS } from 'src/common/constants/constants';
import { stringToHexColor } from 'src/common/utils/formatters';

interface Gap {
    width?: number | string;
    height?: number | string;
}

interface CustomListProps {
    label: any;
}

const Topic: React.FC<CustomListProps> = ({ label }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                padding: '4px 8px 4px 3px',
                alignItems: 'center',
                lineHeight: '22px',
            }}
        >
            <Box
                sx={{
                    width: 14,
                    height: 14,
                    borderRadius: '8px',
                    m: '5px',
                    border: `3px ${MAPPED_TOPICS?.[label.name]?.COLOR || stringToHexColor(label.name)} solid`,
                }}
            ></Box>
            <Typography sx={{ ml: 1 }} variant="s14w500">
                {MAPPED_TOPICS?.[label.name]?.NAME || label.name}
            </Typography>
        </Box>
    );
};

export default Topic;
